<template>
  <!-- Text a light passes over while Oliver works: something that moves says it is alive. -->
  <span class="shimmer-text"><slot /></span>
</template>

<script>
export default {
  name: "ShimmerText",
};
</script>

<style lang="scss" scoped>
.shimmer-text {
  background: linear-gradient(
    90deg,
    var(--oliver-text-muted) 0%,
    var(--oliver-text-muted) 40%,
    var(--oliver-accent) 50%,
    var(--oliver-text-muted) 60%,
    var(--oliver-text-muted) 100%
  );
  background-size: 250% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: shimmer 2.2s linear infinite;
}

@keyframes shimmer {
  0% {
    background-position: 120% 0;
  }
  100% {
    background-position: -20% 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .shimmer-text {
    animation: none;
    background: none;
    color: var(--oliver-text-muted);
  }
}
</style>
